import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const notifications = [{
  name: 'Sarah',
  location: 'Toronto',
  time: '2 min ago'
}, {
  name: 'María',
  location: 'Miami',
  time: '5 min ago'
}, {
  name: 'Emma',
  location: 'London',
  time: '3 min ago'
}, {
  name: 'Ana',
  location: 'Mexico City',
  time: '8 min ago'
}, {
  name: 'Jessica',
  location: 'Vancouver',
  time: '1 min ago'
}, {
  name: 'Laura',
  location: 'Sydney',
  time: '6 min ago'
}, {
  name: 'Sophie',
  location: 'Paris',
  time: '4 min ago'
}, {
  name: 'Camila',
  location: 'Bogotá',
  time: '7 min ago'
}, {
  name: 'Rachel',
  location: 'New York',
  time: '3 min ago'
}, {
  name: 'Valentina',
  location: 'Buenos Aires',
  time: '5 min ago'
}, {
  name: 'Olivia',
  location: 'Melbourne',
  time: '2 min ago'
}, {
  name: 'Claire',
  location: 'Montreal',
  time: '9 min ago'
}];
export function SocialProofToast() {
  const [visible, setVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  useEffect(() => {
    // Show first notification after 12 seconds
    const initialDelay = setTimeout(() => {
      setVisible(true);
    }, 12000);
    return () => clearTimeout(initialDelay);
  }, []);
  useEffect(() => {
    if (!visible) return;
    // Hide after 5 seconds
    const hideTimer = setTimeout(() => {
      setVisible(false);
    }, 5000);
    // Show next notification after hiding
    const nextTimer = setTimeout(() => {
      setCurrentIndex(prev => (prev + 1) % notifications.length);
      setVisible(true);
    }, 20000 + Math.random() * 10000); // 20-30 seconds between notifications
    return () => {
      clearTimeout(hideTimer);
      clearTimeout(nextTimer);
    };
  }, [visible, currentIndex]);
  const notification = notifications[currentIndex];
  return <AnimatePresence data-id="element-190">
      {visible && <motion.div initial={{
      opacity: 0,
      y: 30,
      scale: 0.95
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.95
    }} transition={{
      duration: 0.5,
      ease: 'easeOut'
    }} className="fixed bottom-6 left-1/2 -translate-x-1/2 z-40 max-w-[320px] w-[90%]" data-id="element-191">
          <div className="bg-white/80 backdrop-blur-xl rounded-2xl px-5 py-3.5 shadow-[0_8px_30px_rgba(201,166,107,0.15),0_2px_8px_rgba(0,0,0,0.06)] border border-white/70 flex items-center gap-3.5" data-id="element-192">
            {/* Soft pulsing dot */}
            <div className="flex-shrink-0" data-id="element-193">
              <span className="relative flex h-2 w-2" data-id="element-194">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#C9A66B] opacity-40" data-id="element-195"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-[#C9A66B]" data-id="element-196"></span>
              </span>
            </div>

            <div className="flex-1 min-w-0" data-id="element-197">
              <p className="font-inter text-charcoal text-[11px] leading-snug" data-id="element-198">
                <span className="font-semibold text-copper" data-id="element-199">
                  {notification.name}
                </span>
                <span className="opacity-60" data-id="element-200">
                  {' '}
                  from {notification.location}
                </span>
              </p>
              <p className="font-inter text-[10px] opacity-40 mt-0.5" data-id="element-201">
                just got her Sanctuary · {notification.time}
              </p>
            </div>

            {/* Small heart icon */}
            <span className="text-copper/40 text-xs flex-shrink-0" data-id="element-202">🤍</span>
          </div>
        </motion.div>}
    </AnimatePresence>;
}